import { error } from "util";
import { ImagePreviewComponent } from "./../image-preview/image-preview.component";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { Subscription } from "rxjs/Subscription";
import { AuthenticationService } from "../../authentication.service";
import { DataService } from "../../data.service";
import * as moment from "moment";

declare var $: any;
declare var toastr: any;
declare var Nanobar: any;
declare var toastr: any;
@Component({
  selector: "app-chat-modal",
  templateUrl: "./chat-modal.component.html",
  styleUrls: ["./chat-modal.component.css"],
})
export class ChatModalComponent implements OnInit, AfterContentChecked {
  nao = new Nanobar();
  conversationId: any;
  textMessage: string = "";
  imageMessage: File;
  imageMessageBase64: string | ArrayBuffer = "";
  clientProfile: {
    order_id: string;
    name: string;
    phone_number: string;
  } = {
    order_id: "",
    name: "",
    phone_number: "",
  };
  messageData: any;
  messageListing: any[] = [];
  adminName: string = "";
  loading: boolean = false;
  loadingModalContent: boolean = false;
  messageInputFlag: boolean = false;
  sendButtonFlag: boolean = false;
  @Input("data") data: any;
  @Input("order") order: number;
  @Output("modalClose") modalClose: EventEmitter<any> = new EventEmitter();
  constructor(
    private dataService: DataService,
    private authService: AuthenticationService,
    private cdRef: ChangeDetectorRef,
    private activeModal: NgbActiveModal,
    public modalService: NgbModal
  ) {}

  ngOnInit() {
    if (this.order == 0) {
      this.data["order_text_id"] = this.data.order_id;
      this.data["order_request_id"] = this.data.order_no;
    }
    this.adminName = localStorage.getItem("displayName");
    this.getMessages();
  }

  onMessageImageChange(file) {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => {
      this.imageMessageBase64 = reader.result;
    };
    this.messageInputFlag = true;
    this.imageMessage = file;
  }

  cancelImage() {
    this.imageMessageBase64 = "";
    this.imageMessage = null;
    this.sendButtonFlag = false;
    this.messageInputFlag = false;
  }

  imagePreview: string = "";
  //image preview
  openImagePreview(image) {
    const modalRef = this.modalService.open(ImagePreviewComponent, {
      centered: true,
      windowClass: "in",
      backdropClass: "in",
      size: "sm",
    });
    modalRef.componentInstance.image = image;
  }

  messageSubscription: Subscription;
  page: number = 0;
  limitMessage: number = 15;
  paginationData: any[] = [];
  loadingMessages: boolean = false;
  lastMessageCreatedDate: string = "";
  lastMessageId: any = -1;

  //get Message listing
  getMessages() {
    this.messageListing = [];
    this.page = 0;
    this.clientProfile = {
      order_id: this.data.order_request_id,
      name: this.data.client_name,
      phone_number: this.data.client_phone_number,
    };
    let params = {
      auth_token: localStorage.getItem("token"),
      order_id: this.data.order_text_id,
      order_request: this.order,
      page: this.page,
      limit: this.limitMessage,
    };
    var scope = this;
    this.loadingMessages = true;
    this.nao.go(30);
    this.dataService.getMessageListing(params).subscribe(
      (data: any) => {
        this.nao.go(100);

        if (data.rest_error_code) {
          toastr.error("Something went wrong!");
          this.activeModal.close();
        }
        this.conversationId = data.conversation_id;
        this.messageStatusChangedToRead(this.conversationId);
        this.messageData = data;
        this.messageListing = data.items;
        console.log("this.messageListing", this.messageListing);

        this.loadingModalContent = true;
        if (!this.messageListing.length) {
          this.loading = true;
        }
        this.messageListing.forEach((element) => {
          element.created_time = moment(element.created_time, "LTS")
            .local()
            .format("LT");
        });
        this.messageListing.reverse();
        this.loadingMessages = false;
        setTimeout(() => {
          $("#message-body").animate(
            { scrollTop: $("#message-body").prop("scrollHeight") },
            1000
          );
          setTimeout(() => {
            $("#message-body").on("scroll", function () {
              console.log("scrollll");
              var scrollTop = $(this).scrollTop();
              var topDistance = $(this).offset().top;
              if (
                scrollTop == 0 &&
                !scope.messageData.last_page &&
                !scope.loadingMessages
              ) {
                params.page++;
                scope.getMessagingListing(params);
              }
            });
          }, 1000);
        }, 500);
        this.messageSubscription = this.authService.currentMessage.subscribe(
          (value: any) => {
            console.log("valueee", value);

            if (value != null) {
              if (value.thread_id == this.conversationId) {
                value.self = false;
                this.messageListing.push(value);
                this.messageListing.forEach((element) => {
                  element.created_time = moment(element.created_time, "LTS")
                    .local()
                    .format("LT");
                });
                $("#message-body").animate(
                  { scrollTop: $("#message-body").prop("scrollHeight") },
                  500
                );
              }
            }
          }
        );
      },
      (error) => {
        toastr.error("Something went wrong!");
      }
    );
  }

  messageStatusChangedToRead(conversationId) {
    let params = {
      auth_token: localStorage.getItem("token"),
      conversation_id: conversationId,
    };
    this.dataService.messageStatusChangeToRead(params).subscribe(
      (data: any) => {
        if (data.success) {
        }
      },
      (error) => {
        toastr.error("Something went wrong!");
      }
    );
  }

  validateMessageData() {
    this.sendButtonFlag = true;
    if (!this.imageMessage && !this.textMessage) {
      this.sendButtonFlag = false;
      return toastr.error("Please enter a message or select an image.");
    } else if (this.imageMessage) {
      this.uploadMessageImage();
    } else {
      this.sendMessage();
    }
  }

  uploadMessageImage() {
    this.nao.go(30);
    let param_data = {
      auth_token: localStorage.getItem("token"),
      image: this.imageMessage,
    };
    if (this.imageMessage) {
      this.dataService.sendMessageImage(param_data).subscribe(
        (data: any) => {
          this.nao.go(100);
          if (data.url) {
            this.imageMessage = null;
            this.imageMessageBase64 = "";
            this.sendMessage(data.url || "");
          } else {
            toastr.error("Something went wrong!");
          }
        },
        (error) => {
          toastr.error("Something went wrong!");
        }
      );
    }
  }

  //send message
  sendMessage(image_url: string = "") {
    this.nao.go(30);
    this.textMessage = this.textMessage.trim();
    let params = {
      auth_token: localStorage.getItem("token"),
      conversation_id: this.conversationId,
      text: this.textMessage,
      image: image_url,
    };
    this.dataService.sendMessage(params).subscribe(
      (data: any) => {
        this.messageInputFlag = false;
        this.sendButtonFlag = false;
        this.textMessage = "";
        this.messageListing.push(data);
        this.messageListing.forEach((element) => {
          element.created_time = moment(element.created_time, "LTS")
            .local()
            .format("LT");
        });
        $("#message-body").animate(
          { scrollTop: $("#message-body").prop("scrollHeight") },
          1000
        );
        if (data) {
        } else {
          toastr.error("Something went wrong!");
          this.sendButtonFlag = false;
        }
        this.nao.go(100);
      },
      (error) => {
        toastr.error("Something went wrong!");
        this.sendButtonFlag = false;
      }
    );
  }

  getMessagingListing(params) {
    this.loadingMessages = true;
    this.nao.go(30);
    this.dataService.getMessageListing(params).subscribe((data: any) => {
      this.nao.go(100);
      this.conversationId = data.conversation_id;
      this.messageData = data;
      this.paginationData = data.items;

      this.paginationData.forEach((element) => {
        element.created_time = moment(element.created_time, "LTS")
          .local()
          .format("LT");
      });
      this.paginationData.reverse();
      this.messageListing = [...this.paginationData, ...this.messageListing];
      this.messageListing.forEach((element) => {
        element.created_time = moment(element.created_time, "LTS")
          .local()
          .format("LT");
      });
      this.loadingMessages = false;
    });
  }

  checkMessageDate(message_date): boolean {
    if (message_date.localeCompare(this.lastMessageCreatedDate) != 0) {
      this.lastMessageCreatedDate = message_date;
      return true;
    } else {
      return false;
    }
  }
  checkMessageDuplicate(message, index): boolean {
    if (index != 0) {
      if (message.id != this.lastMessageId) {
        this.lastMessageId = message.id;
        return true;
      }
      if (message.id === this.lastMessageId) {
        return true;
      } else {
        return false;
      }
    } else {
      this.lastMessageId = message.id;
      return true;
    }
  }

  ngAfterContentChecked(): void {
    this.cdRef.detectChanges();
  }

  closeModal() {
    this.modalClose.emit(true);
    this.activeModal.close();
    this.messageSubscription.unsubscribe();
  }

  ngOnDestroy() {
    if (this.messageSubscription) {
      this.messageSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modals/chat-modal/chat-modal.component.ts